import { render } from "./applicant_choose.vue?vue&type=template&id=70fb3812"
import script from "./applicant_choose.vue?vue&type=script&lang=js"
export * from "./applicant_choose.vue?vue&type=script&lang=js"

import "./applicant_choose.vue?vue&type=style&index=0&id=70fb3812&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__